'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useUserContext } from '../contexts/UserContext';
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import Chart from './Chart';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { ResponsiveContainer, ScatterChart, XAxis, YAxis, Tooltip, Scatter, CartesianGrid, Rectangle } from 'recharts';
import { set } from 'date-fns';

let signalstopic = 'goldensparrowcapital-signals';

const Symbols = props => {
  const {
    user
  } = useUserContext();
  const sidePanelRef = useRef(null);
  const [section, setSection] = useState('Active')
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // holds the MQTT client instance
  const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [isProcessing, setIsProcessing] = useState(false)
  const [symbols, setSymbols] = useState([])
  const [sidePanel, setSidePanel] = useState({
    visible: false,
    symbol: null,
    lastUpdated: new Date().valueOf(),
    strategies: [],
    fvg: [],
    heavyTrade: [],
    currentPrices: [],
    rsiCrossedSmaBelowBbMiddle: [],
    belowBBLower: [],
    heavyAbsorption: [],
    heavySelling: [],
    breakoutPhaseStarted: [],
    artificialPumpStarted: [],
    spoofingLayeringDetected: [],
    absorptionViaStreams: [],
    dollarValue: [],
    strategyA: [],
    hotSpots: [],
    strategyC : []

  })
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  const [xDomain, setXDomain] = useState(['dataMin', 'dataMax']);
  const [yDomain, setYDomain] = useState(['dataMin', 'dataMax']);
  const origDomainsRef = useRef({ x: null, y: null });


  const addIntoRecentlyViewed = (symbol) => {
    //check if symbol already exists in recentlyViewed
    setRecentlyViewed((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.symbol === symbol);
      if (index == -1) {
        //add it to the recentlyViewed
        //use push
        updated.push({ symbol, creationDate: Date.now() });
      }
      return updated;
    });
  };

  const removeFromRecentlyViewed = (symbol) => {
    setRecentlyViewed((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.symbol === symbol);
      if (index !== -1) {
        updated.splice(index, 1);
      }
      return updated;
    });
  };

  // Render Metric shapes inside the Scatter plot
  // Recharts provides pixel coordinates cx/cy for each point — use them if valid.

  //connect and subscribe to MQTT broker
  const _connectMQTT = useCallback(async (props) => {
    if (mqttClientRef.current) return; // already connected
    let clientID = 'GoldenSparrowCapital-' + user.user_uuid;
    const gsccookie = Cookies.get('gsccookie') || null;
    const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
      clientId: clientID,
      username: 'user-jwt',
      password: gsccookie,
      clean: true,
      rejectUnauthorized: true,
      reconnectPeriod: 60000,
    });
    mqttClientRef.current = newClient;
    setClient(newClient);

    newClient.on('connect', async () => {
      console.log('Connected to MQTT:', new Date().toLocaleTimeString());

      [
        'RECEIVE_SYMBOLS_WEB',
        'RECEIVE_SYMBOL_STRATEGIES_AND_METRICS_WEB'
      ].forEach(topic => {
        newClient.unsubscribe(topic);
        newClient.subscribe(topic, err => {
          if (err) {
            console.error('Topic Subscribe error', err);
          }
        });
      });
    });
  }, [setClient, setIsProcessing]);

  //i want publishGetSymbolsList() to be called every 1 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      publishGetSymbolsList();
    }, 1 * 60 * 1000); // 1 minutes
    return () => clearInterval(interval);
  }, [client]);

  const sidePanelSymbolRef = useRef(null);
  useEffect(() => {
    sidePanelSymbolRef.current = sidePanel.visible ? sidePanel.symbol : null;
  }, [sidePanel.visible, sidePanel.symbol]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sidePanelSymbolRef.current !== null) {
        publishGetSymbolData(sidePanelSymbolRef.current);
      }
    }, 1 * 60 * 1000); // 1 minute
    return () => clearInterval(interval);
  }, []);
 

  useEffect(() => {
    if (!client || mqttListenerAttached.current) return;
    const handler = (topic, message = '') => {
      //  console.log('Received Topic:', topic, new Date().toLocaleTimeString());
      if (topic === 'RECEIVE_SYMBOLS_WEB') {
        let mm = JSON.parse(message);
        //  console.log("Symbols:", mm.symbols)

        setSymbols(prev => [...mm.symbols]);
        setLastUpdated(new Date().valueOf());
      }
      if (topic === 'RECEIVE_SYMBOL_STRATEGIES_AND_METRICS_WEB') {
        let mm = JSON.parse(message);
        // console.log("Strategies and Metrics:", mm)
if(mm.symbol==sidePanel.symbol) {

        setSidePanel(prev => ({
          ...prev,
          visible: true,
          symbol: mm.symbol || prev.symbol,

          strategies: Array.isArray(mm.strategies) ? [...mm.strategies] : [],
          // Create NEW array references to force React re-render
          fvg: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'FVG' && item.timeFrame == "4h" && item.candleMinus1 && item.candleMinus2 && item.candleMinus3))]
            : [],
          heavyTrade: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'HEAVY-TRADE' || item.metricName === 'HEAVY_TRADE'))]
            : [],
          currentPrices: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'CURRENT-PRICE'))]
            : [],
          rsiCrossedSmaBelowBbMiddle: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'RSI_CROSSED_SMA_BELOW_BBMIDDLE'))]
            : [],
          belowBBLower: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'BELOW_BBLOWER'))]
            : [],
          heavyAbsorption: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'HEAVY-ABSORPTION'))]
            : [],
          heavySelling: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'HEAVY-SELLING'))]
            : [],
          dollarValue: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'DOLLAR_VALUE'))]
            : [],
          absorptionViaStreams: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'ABSORPTION_DETECTED'))]
            : [],
          strategyA: Array.isArray(mm.metrics)
            ? [...(mm.metrics.filter(item => item.metricName === 'STRATEGY_A'))]
            : [],
            strategyC: Array.isArray(mm.metrics)
              ? [...(mm.metrics.filter(item => item.metricName === 'STRATEGY_C'))]
              : [], 
          hotSpots: Array.isArray(mm.hotSpots) ? [...mm.hotSpots] : [],
          lastUpdated: Date.now(),
          total: Array.isArray(mm.metrics) ? mm.metrics.length : 0
        }));
      }

        //  console.log("Hot Spots:", JSON.stringify(mm.hotSpots,0,4));

        // console.log one object of metricName == "FVG"
        // console.log("FVG Metric:", (mm.metrics || []).find(item => item.metricName === 'FVG' && item.type === 'PRIMARY' && item.timeFrame == "4h"));
        //console.log("HEAVY-TRADE Metric:", (mm.metrics || []).find(item => item.metricName === 'HEAVY-TRADE'));



      }

    };
    client.on('message', handler);
    mqttListenerAttached.current = true;
    return () => {
      if (mqttClientRef.current) {
        mqttClientRef.current.end();
        mqttClientRef.current = null;
        setClient(null);
        mqttListenerAttached.current = false;
      }
    };
  }, [client, setIsProcessing]);

  useEffect(() => {
    _connectMQTT(props);
    publishGetSymbolsList();
  }, []);

  const publishGetSymbolsList = useCallback(() => {
    const client = mqttClientRef.current;
    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('GET_SYMBOLS', JSON.stringify({ token: gsccookie }), err => {
        if (!err) {
          setIsProcessing(true);
          console.log('GET_SYMBOLS request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client);
  }, [_connectMQTT, setIsProcessing]);

  const publishGetSymbolData = useCallback((symbol) => {
    setSidePanel(prev => ({
      ...prev,
      symbol: symbol,
      visible: true,
      lastUpdated: new Date().valueOf()
    }));

    const client = mqttClientRef.current;

    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c, s) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('GET_SYMBOL_STRATEGIES_AND_METRICS',
        JSON.stringify({ token: gsccookie, symbol: s }), err => {
          if (!err) {
            setIsProcessing(true);
            console.log('GET_SYMBOL_STRATEGIES_AND_METRICS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client, symbol);

  }, [_connectMQTT, setIsProcessing]);

  const deleteSymbol = useCallback((symbol) => {

    //delete from symbols 
    setSymbols(prev => prev.filter(item => item.symbol !== symbol));

    const client = mqttClientRef.current;
    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('DELETE_SYMBOL_FROM_LIST', JSON.stringify({ token: gsccookie, symbol }), err => {
        if (!err) {
          setIsProcessing(true);
          console.log('DELETE_SYMBOL_FROM_LIST request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client);
  }, [_connectMQTT, setIsProcessing]);

const scrollSidePanelIntoView = () => {
  // Wait for React to render the panel before scrolling
  requestAnimationFrame(() => {
    sidePanelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
};



  return symbols ? (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      {sidePanel.visible && (
        <div ref={sidePanelRef} style={{
        //  backgroundColor:"black",
         // overflowY: 'auto',  // Make sure this exists
          padding: 10,
          // position: 'fixed',
          // top: 0,
          // bottom: 0,
          // right: 0,
          // width: '85%',  // or specific width like '800px'
          // zIndex: 1000,  // Add this to ensure it's above main content
          // maxWidth: '100%'
        }}>
          <div style={{
            //  borderRadius: "5px", 
            display: "flex",
            // borderBottom: "1px solid #eee"
          }}>
            <h5 style={{ color: "#fff", padding: "5px", fontWeight: "bold" }}>{sidePanel.symbol}
              ({sidePanel.total})
            </h5>

            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.coinglass.com/tv/Binance_' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
              <svg
                width="15"
                height="15"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Dark background circle matching trading terminal themes */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                <path
                  d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                {/* Subtle outer border for depth */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>

            </button>
            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Standard Terminal Background */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                {/* Border for UI consistency */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>
            </button>

            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.tradingview.com/symbols/' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View IDEAS</h4>
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Standard Terminal Background */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />
                <path
                  d="M9 18h6v1a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1z"
                  aria-hidden="true"
                />

                <path
                  d="M9 18h6v1a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1z"
                  fill="#4B5563"
                />
                <path
                  d="M12 2C8.686 2 6 4.686 6 8c0 2.042.9 3.43 1 3.536V13a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-1.464C17.1 11.43 18 10.042 18 8c0-3.314-2.686-6-6-6z"
                  fill="#FFD54A"
                  stroke="#D97706"
                  strokeWidth="0.4"
                />
                <path
                  d="M11 14h2v2h-2z"
                  fill="#F59E0B"
                />
                <path
                  d="M10.2 7.2c.45-.5 1.05-.8 1.8-.8.75 0 1.35.3 1.8.8"
                  stroke="#92400E"
                  strokeWidth="0.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>

            </button>


            <button
              style={{
                backgroundColor: '#ff0000',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {

                setSidePanel({
                  visible: false,
                  symbol: null,
                  lastUpdated: null,
                  strategies: [],
                  fvg: [],
                  heavyTrade: [],
                  currentPrices: [],
                  rsiCrossedSmaBelowBbMiddle: [],
                  belowBBLower: [],
                  heavyAbsorption: [],
                  heavySelling: [],
                  breakoutPhaseStarted: [],
                  artificialPumpStarted: [],
                  spoofingLayeringDetected: [],
                  absorptionViaStreams: [],
                  dollarValue: [],
                  strategyA: [],
                  strategyC: [],
                  hotSpots: [],
                  total: 0

                })


              }}
            >
              <h4 style={{ fontWeight: 'bolder', color: 'white' }}>Close</h4>


            </button>
            <button
              style={{
                backgroundColor: '#6e716eff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                publishGetSymbolData(sidePanel.symbol);
              }}
            >
              <h4 style={{ fontWeight: 'bolder', color: 'white' }}>Refresh</h4>


            </button>

          </div>
          <span style={{ fontSize: 11, color: 'grey', marginLeft: 5 }}>
            Last Updated: {new Date(sidePanel.lastUpdated).toLocaleString()}
          </span>

          <div style={{
            display: "flex",
          }}>


            {/* Timeframe dropdown */}
            <div style={{ marginLeft: 8, display: 'inline-block' }}>
              <label htmlFor="timeframe-select" style={{ color: '#fff', fontSize: 12, marginRight: 6 }}>Timeframe:</label>
              <select
                id="timeframe-select"
                value={sidePanel.selectedTimeframe || '15m'}
                onChange={(e) => setSidePanel(prev => ({ ...prev, selectedTimeframe: e.target.value }))}
                style={{
                  backgroundColor: '#1f2937',
                  color: '#fff',
                  border: '1px solid #374151',
                  borderRadius: 6,
                  padding: '6px 8px',
                  fontSize: 12,
                  outline: 'none'
                }}
              >
                <option value="15m">15m</option>
                <option value="30m">30m</option>
                <option value="1h">1h</option>
                <option value="4h">4h</option>
                <option value="1D">1D</option>
                <option value="1W">1W</option>
              </select>
            </div>
            {/* Day dropdown */}
            <div style={{ marginLeft: 8, display: 'inline-block' }}>
              <label htmlFor="day-select" style={{ color: '#fff', fontSize: 12, marginRight: 6 }}>Day:</label>
              <select
                id="day-select"
                value={(sidePanel.selectedDay || String(new Date().getDate()))}
                onChange={(e) => setSidePanel(prev => ({ ...prev, selectedDay: e.target.value }))}
                style={{
                  backgroundColor: '#1f2937',
                  color: '#fff',
                  border: '1px solid #374151',
                  borderRadius: 6,
                  padding: '6px 8px',
                  fontSize: 12,
                  outline: 'none'
                }}
              >
                {Array.from({ length: 31 }, (_, i) => {
                  const day = i + 1;
                  return <option key={day} value={String(day)}>{day}</option>;
                })}
              </select>
            </div>

            {/* Month dropdown */}

            <div style={{ marginLeft: 8, display: 'inline-block' }}>
              <label htmlFor="month-select" style={{ color: '#fff', fontSize: 12, marginRight: 6 }}>Month:</label>
              <select
                id="month-select"
                value={sidePanel.selectedMonth || String(new Date().getMonth() + 1)}
                onChange={(e) => setSidePanel(prev => ({ ...prev, selectedMonth: e.target.value }))}
                style={{
                  backgroundColor: '#1f2937',
                  color: '#fff',
                  border: '1px solid #374151',
                  borderRadius: 6,
                  padding: '6px 8px',
                  fontSize: 12,
                  outline: 'none'
                }}
              >
                {[
                  'January', 'February', 'March', 'April', 'May', 'June',
                  'July', 'August', 'September', 'October', 'November', 'December'
                ].map((m, i) => (
                  <option key={i} value={String(i + 1)}>{m}</option>
                ))}
              </select>
            </div>

            {/* Year dropdown */}
            <div style={{ marginLeft: 8, display: 'inline-block' }}>
              <label htmlFor="year-select" style={{ color: '#fff', fontSize: 12, marginRight: 6 }}>Year:</label>
              <select
                id="year-select"
                value={sidePanel.selectedYear || String(new Date().getFullYear())}
                onChange={(e) => setSidePanel(prev => ({ ...prev, selectedYear: e.target.value }))}
                style={{
                  backgroundColor: '#1f2937',
                  color: '#fff',
                  border: '1px solid #374151',
                  borderRadius: 6,
                  padding: '6px 8px',
                  fontSize: 12,
                  outline: 'none'
                }}
              >
                {Array.from({ length: 10 }, (_, i) => {
                  const year = new Date().getFullYear() - i;
                  return <option key={year} value={String(year)}>{year}</option>;
                })}
              </select>

            </div>

            <button
              style={{
                backgroundColor: '#ff0000ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                // Save the current state or perform any save action
              }}
            >
              <h4 style={{ fontWeight: 'bolder', color: 'white' }}>Save</h4>
            </button>

          </div>

          <div style={{ height: 800, width: '100%', marginTop: 10, marginLeft: 5 }}>
            <Chart
              fvgs={sidePanel.fvg}
              heavyTrades={sidePanel.heavyTrade}
              currentPrices={sidePanel.currentPrices}
              rsiCrossedSmaBelowBbMiddle={sidePanel.rsiCrossedSmaBelowBbMiddle}
              belowBBLower={sidePanel.belowBBLower}
              heavyAbsorption={sidePanel.heavyAbsorption}
              heavySelling={sidePanel.heavySelling}

              // breakoutPhaseStarted={sidePanel.breakoutPhaseStarted}
              // artificialPumpStarted={sidePanel.artificialPumpStarted}
              // spoofingLayeringDetected={sidePanel.spoofingLayeringDetected}
              absorptionViaStreams={sidePanel.absorptionViaStreams}
              dollarValue={sidePanel.dollarValue}
              strategyA={sidePanel.strategyA}
              strategyC={sidePanel.strategyC}
              hotSpots={sidePanel.hotSpots}

            />


          </div>

        </div>
      )}

      {/* Main Page */}

      <div className="flex">
        <main className="flex-1 p-0">
          {recentlyViewed.length > 0 ?
       <div>
             <h1 className="text-xl font-bold">Recently viewed</h1>
        
            <div className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg" style={{ padding: 10 }}>

              {/* <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3, marginTop: 5, fontWeight: "bold" }}> Recently Viewed: </h1> */}
          
                {recentlyViewed.map((item, index) => (
                  //display the name of each symbol in new line and also give a button to remove it from the recentlyViewed

                  <div key={index} style={{ display: 'flex', gap: 5, marginTop: 5 }}>

                    <h2 style={{ fontSize: 12 }}>{index + 1}. {item.symbol}</h2>
                    <button style={{
                      backgroundColor: '#fe0000ff',
                      fontSize: 12,
                      borderRadius: 5,
                      padding: 3,
                      alignItems: 'center', display: 'flex',

                    }}
                      onClick={() => removeFromRecentlyViewed(item.symbol)}>
                      Remove
                    </button>
                    <button
                      style={{
                        backgroundColor: '#7e8082ff',
                        fontSize: 12,
                        borderRadius: 5,
                        padding: 3,
                        alignItems: 'center', display: 'flex',

                      }}
                      onClick={() => {
                        window.open(
                          'https://www.coinglass.com/tv/Binance_' + item.symbol,
                          '_blank'
                        )

                      }}
                    >
                      <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                      >
                        {/* Dark background circle matching trading terminal themes */}
                        <circle cx="16" cy="16" r="16" fill="#1E222D" />

                        {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                        <path
                          d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />

                        {/* Subtle outer border for depth */}
                        <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                      </svg>

                    </button>
                    <button
                      style={{
                        backgroundColor: '#7e8082ff',
                        fontSize: 12,
                        borderRadius: 5,
                        padding: 3,
                        alignItems: 'center', display: 'flex',

                      }}
                      onClick={() => {
                        window.open(
                          'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                          '_blank'
                        )

                      }}
                    >
                      <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                      >
                        {/* Standard Terminal Background */}
                        <circle cx="16" cy="16" r="16" fill="#1E222D" />

                        {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                        <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                        <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                        <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                        {/* Border for UI consistency */}
                        <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                      </svg>
                    </button>
                    <button
                      style={{
                        backgroundColor: '#298f09ff',
                        fontSize: 12,
                        borderRadius: 5,
                        padding: 3,
                        alignItems: 'center', display: 'flex',

                      }}
                      onClick={async () => {
                          scrollSidePanelIntoView();
                        await publishGetSymbolData(item.symbol);

                      }}
                    >
                      <h5 style={{ fontWeight: 'bolder' }}>Show chart...</h5>
                    </button>

                  </div>

                ))}
            </div>
            </div>
          : null}

          <header className="mb-2">
            <h1 className="text-2xl font-bold">Symbols</h1>
          </header>
          <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, fontSize: 11, color: 'grey', marginLeft: 5 }}> Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
            {new Date(lastUpdated).toLocaleTimeString()}
          </h1>
          {/* <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}> Count: {' '}
              {symbols.length}
            </h1> */}



          <table
            style={{ marginTop: 5 }}
            className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left text-xs">Symbol</th>
                <th className="py-2 px-4 border-b text-center text-xs">Metric Name</th>
                <th className="py-2 px-4 border-b text-center text-xs">Timeframe</th>
                <th className="py-2 px-4 border-b text-center text-xs">Last Updated</th>
                {/* <th className="py-2 px-4 border-b">Data </th> 
                <th className="py-2 px-4 border-b">Metric Name</th>
                <th className="py-2 px-4 border-b">TimeFrame</th> */}
              </tr>
            </thead>
            <tbody>
              {
                // order by desc updatedDate using numeric timestamp to ensure proper sorting
                // Ensure numeric sorting: coerce updatedDate and fvgPercentage to numbers before ordering.
                _.orderBy(
                  symbols,
                  // [
                  //   // bucket updatedDate to the hour only (ignore minutes/seconds) for sorting
                  //   (s) => {
                  //     if (s == null) return 0;
                  //     let t = Number(s.updatedDate);
                  //     if (!Number.isFinite(t)) {
                  //       const parsed = Date.parse(String(s.updatedDate || ''));
                  //       t = Number.isFinite(parsed) ? parsed : 0;
                  //     }
                  //     // return hour bucket (hours since epoch) so sorting ignores minutes/seconds
                  //     return t ? Math.floor(t / 3600000) : 0;
                  //   },
                  //   (s) => {
                  //     // fvgPercentage may be a string (e.g. '12' or '12.3') — coerce to number
                  //     // also allow values like '12%' by stripping non-numeric characters
                  //     if (s == null) return 0;
                  //     const raw = s.fvgPercentage;
                  //     if (raw == null) return 0;
                  //     const num = Number(String(raw).replace(/[^0-9.-]+/g, ''));
                  //     return Number.isFinite(num) ? num : 0;
                  //   }
                  // ],
                  ["updatedDate"],
                  ['desc']
                )

                  .map((item, index) => (
                    <tr key={index}>
                      <td className="py-2 px-4 border-b flex items-center">
                        <div style={{ alignItems: 'center', display: 'flex', gap: 5 }}>
                          <h2>{index + 1}.</h2>
                          <h2 style={{ fontSize: 12 }}>{item.symbol}</h2>
                          <button
                            style={{
                              backgroundColor: '#298f09ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex',

                            }}
                            onClick={async () => {
                              addIntoRecentlyViewed(item.symbol);
                               scrollSidePanelIntoView();
                              await publishGetSymbolData(item.symbol);
                            }}
                          >
                            <h5 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Show chart...</h5>


                          </button>
                          <button
                            style={{
                              backgroundColor: '#7e8082ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex'
                            }}
                            onClick={() => {
                              window.open(
                                'https://www.coinglass.com/tv/Binance_' + item.symbol,
                                '_blank'
                              )

                            }}
                          >
                            <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                            >
                              {/* Dark background circle matching trading terminal themes */}
                              <circle cx="16" cy="16" r="16" fill="#1E222D" />

                              {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                              <path
                                d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />

                              {/* Subtle outer border for depth */}
                              <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                            </svg>

                          </button>
                          <button
                            style={{
                              backgroundColor: '#7e8082ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex'
                            }}
                            onClick={() => {
                              window.open(
                                'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                                '_blank'
                              )

                            }}
                          >
                            <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                            >
                              {/* Standard Terminal Background */}
                              <circle cx="16" cy="16" r="16" fill="#1E222D" />

                              {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                              <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                              <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                              <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                              {/* Border for UI consistency */}
                              <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                            </svg>
                          </button>

                          <button
                            style={{
                              backgroundColor: 'red',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex',

                            }}
                            onClick={async () => {
                              deleteSymbol(item.symbol);
                            }}
                          >
                            <h5 style={{ fontWeight: 'bolder' }}>Delete</h5>
                          </button>
                        </div>
                      </td>
                      <td className="py-2 px-4 border-b text-center text-xs">{item?.metricName}</td>
                      <td className="py-2 px-4 border-b text-center text-xs">{item.timeFrame}</td>
                      <td className="py-2 px-4 border-b text-center" style={{ fontSize: 9 }}>{new Date(item.updatedDate).toLocaleString()}</td>


                    </tr>
                  ))}
            </tbody>
          </table>
        </main>
      </div>


   
    </div>
  ) : null;

};


export default Symbols;
